import { render, staticRenderFns } from "./ModalMenu.vue?vue&type=template&id=2bd0c51b&scoped=true&"
import script from "./ModalMenu.vue?vue&type=script&lang=js&"
export * from "./ModalMenu.vue?vue&type=script&lang=js&"
import style0 from "./ModalMenu.vue?vue&type=style&index=0&id=2bd0c51b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0c51b",
  null
  
)

export default component.exports